import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useZendeskMessaging } from './ZendeskMessagingProvider';

const ZendeskSupportContextBridge = () => {
  const { pathname } = useLocation();
  const { updateSupportRoute } = useZendeskMessaging();

  useEffect(() => {
    updateSupportRoute(pathname);
  }, [pathname, updateSupportRoute]);

  return null;
};

export default ZendeskSupportContextBridge;
